import googleAnalyticsMiddleware from './google-analytics-middleware';

export default googleAnalyticsMiddleware;
